import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { UPLOADING_IMAGE_URL } from '../../../../../define/consts/assets';
import { propShape, propFunc } from '../../../../../helpers/custom-prop-types';
import Image from '../../../../Ui/Common/Image';
const ProfessionalUnitCompanyContactIntroduction = (props) => {
    const { onClick, unit } = props;
    const { organization: { introductionFileImageCount, introductionFileProgressCount, introductionImages, }, } = unit;
    const isUploading = introductionFileImageCount >= 0 &&
        introductionFileProgressCount >= 0 &&
        introductionFileImageCount !== introductionFileProgressCount;
    const thumbnail = isUploading ? UPLOADING_IMAGE_URL : introductionImages[0];
    if (!introductionImages.length) {
        return null;
    }
    return (_jsx("div", Object.assign({ className: 'introduction_box' }, { children: _jsx("div", Object.assign({ className: clsx('introduction_inner', !isUploading && 'pointer'), onClick: isUploading || !thumbnail ? undefined : onClick, role: 'presentation' }, { children: _jsx(Image, { allowContextMenu: false, alt: '', className: 'introduction_thumbnail', isObjectFit: true, src: thumbnail, useImage: true }) })) })));
};
ProfessionalUnitCompanyContactIntroduction.propTypes = {
    onClick: propFunc().isRequired,
    unit: propShape().isRequired,
};
export default ProfessionalUnitCompanyContactIntroduction;
